/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {Subscription} from 'rxjs/Subscription';
import {ScrollStrategy, getMdScrollStrategyAlreadyAttachedError} from './scroll-strategy';
import {OverlayRef} from '../overlay-ref';
import {ScrollDispatcher} from '@angular/cdk/scrolling';

/**
 * Config options for the RepositionScrollStrategy.
 */
export interface RepositionScrollStrategyConfig {
  scrollThrottle?: number;
}
/**
 * Strategy that will update the element position as the user is scrolling.
 */
export class RepositionScrollStrategy implements ScrollStrategy {
private _scrollSubscription: Subscription|null = null;
private _overlayRef: OverlayRef;
/**
 * @param {?} _scrollDispatcher
 * @param {?=} _config
 */
constructor(
private _scrollDispatcher: ScrollDispatcher,
private _config?: RepositionScrollStrategyConfig) { }
/**
 * @param {?} overlayRef
 * @return {?}
 */
attach(overlayRef: OverlayRef) {
    if (this._overlayRef) {
      throw getMdScrollStrategyAlreadyAttachedError();
    }

    this._overlayRef = overlayRef;
  }
/**
 * @return {?}
 */
enable() {
    if (!this._scrollSubscription) {
      let /** @type {?} */ throttle = this._config ? this._config.scrollThrottle : 0;

      this._scrollSubscription = this._scrollDispatcher.scrolled(throttle, () => {
        this._overlayRef.updatePosition();
      });
    }
  }
/**
 * @return {?}
 */
disable() {
    if (this._scrollSubscription) {
      this._scrollSubscription.unsubscribe();
      this._scrollSubscription = null;
    }
  }
}

function RepositionScrollStrategy_tsickle_Closure_declarations() {
/** @type {?} */
RepositionScrollStrategy.prototype._scrollSubscription;
/** @type {?} */
RepositionScrollStrategy.prototype._overlayRef;
/** @type {?} */
RepositionScrollStrategy.prototype._scrollDispatcher;
/** @type {?} */
RepositionScrollStrategy.prototype._config;
}




// WEBPACK FOOTER //
// ../../../src/cdk/overlay/scroll/reposition-scroll-strategy.ts